import * as React from "react";
import {AreYouReallySureConfirmation} from "./AreYouReallySureConfirmation";

export function DeleteConfirmation({ itemName, deleteWhat, onChange }: { itemName: string, deleteWhat: string, onChange(canDelete: boolean): void }) {
    return <AreYouReallySureConfirmation 
        title={"This is a major destructive action"}
        warning={<>This action <strong>cannot</strong> be undone. This will permanently delete the <strong>{itemName}</strong> {deleteWhat}</>} 
        requiredConfirmation={itemName} 
        onChange={onChange} />
}